import npmx from '../assets/pdf/npmx.png'
import jsonlens from '../assets/pdf/jsonlens.png'
import resumeai from '../assets/pdf/resumeai.png'
import sumz from '../assets/pdf/sumz.png'
import algo from '../assets/pdf/algo.jpeg'
import smartSplit from '../assets/pdf/smartSplit.png'
import made from '../assets/pdf/made.png'
import H from '../assets/pdf/H.png'
import git from '../assets/pdf/git.jpg'
export const projectsData = [
    {
        id: 1,
        projectName: 'NPMX - NPM Spark',
        projectDesc: 'NPMX is a NPM package manager that helps you to manage your NPM packages.',
        tags: ['NextJs', 'Tailwind', 'TypeScript', 'NPM'],
        code: 'https://github.com/VAIBHAV-25/npm-spark',
        demo: 'https://npm-spark.vercel.app/',
        image: npmx
    },
    {
        id: 2,
        projectName: 'JSON Lens',
        projectDesc: 'JSON Lens is a JSON viewer that helps you to view JSON data in a tree structure.',
        tags: ['React', 'CSS', 'APIs'],
        code: 'https://github.com/VAIBHAV-25/JSON-Lens',
        demo: 'https://json-lens-vs.vercel.app/',
        image: jsonlens
    },
    {
        id: 3,
        projectName: 'ResumeAI',
        projectDesc: 'ResumeAI is a resume builder that helps you to build your resume in a few minutes.',
        tags: ['NextJs', 'Tailwind', 'TypeScript', 'AI'],
        code: 'https://github.com/VAIBHAV-25/ResumeAI',
        demo: 'https://analyzeresumeai.netlify.app/',
        image: resumeai
    },
    {
        id: 4,
        projectName: 'Text Sumz',
        projectDesc: 'It leverages the power of OpenAI large language models to automatically generate concise summaries of articles, saving you time and effort.',
        tags: ['NextJs', 'Tailwind', 'Redux', 'JavaScript','TypeScript'],
        code: 'https://github.com/VAIBHAV-25/AI-Text-Summariser',
        demo: 'https://text-sumz.netlify.app/',
        image: sumz
    },
    {
        id: 5,
        projectName: 'SplitSmart',
        projectDesc: 'SplitSmart is a modern, AI-powered expense sharing application designed to simplify group expense management.',
        tags: ['NextJs', 'Tailwind', 'Redux', 'JavaScript','TypeScript'],
        code: 'https://github.com/VAIBHAV-25/SplitSmart',
        demo: 'https://bright-bonbon-42beac.netlify.app/',
        image: smartSplit
    },
    {
        id: 6,
        projectName: 'Algorithm Visualizer',
        projectDesc: 'This is a website where you can see visualization of some famous DSA algorithms.',
        tags: ['NodeJS', 'NextJS', 'React', 'MongoDB'],
        code: 'https://github.com/VAIBHAV-25?tab=repositories',
        demo: 'https://vizalgotool.netlify.app',
        image: algo
    },
    {
        id: 6,
        projectName: 'Made for Maid',
        projectDesc: 'A dynamic webpage from where user can hire maids online',
        tags: ['HTML', 'CSS', 'Javascript', 'PHP', 'MySQL'],
        code: 'https://github.com/VAIBHAV-25?tab=repositories',
        demo: 'https://github.com/VAIBHAV-25?tab=repositories',
        image: made
    },
    {
        id: 7,
        projectName: 'Harvestify',
        projectDesc: 'Website which is capable of Crop recommendation, Fertilizer recommendation and Plant disease prediction',
        tags: ['AI/ML', 'Python', 'Django', 'HTML/CSS'],
        code: 'https://github.com/VAIBHAV-25/Harvestify',
        demo: 'hhttps://github.com/VAIBHAV-25/Harvestify',
        image: H
    },
    {
        id: 8,
        projectName: 'Github',
        projectDesc: 'To have look on some more of my projects do visit my Github account',
        tags: ['Projects', 'Vaibhav'],
        code: 'https://github.com/VAIBHAV-25/',
        demo: 'hhttps://github.com/VAIBHAV-25/',
        image: git
    },
]
